// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2zDJa","vLegacy":"SelectSecondary_vLegacy__2zQb4","error":"SelectSecondary_error__2JxKB","disabled":"SelectSecondary_disabled__2OYei"};